import { render, staticRenderFns } from "./PrimaCardCategory.vue?vue&type=template&id=127ac2b0&"
import script from "./PrimaCardCategory.vue?vue&type=script&lang=js&"
export * from "./PrimaCardCategory.vue?vue&type=script&lang=js&"
import style0 from "./PrimaCardCategory.vue?vue&type=style&index=0&id=127ac2b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports